import Link from 'next/link'

import { Container } from './Container'

export const LpFooter: React.FC<{}> = () => {
  return (
    <>
      <div className="bg-function text-white w-full">
        <Container>
          <div className="mx-5 md:mx-0 h-[70px] flex justify-center flex-col">
            <div className="flex items-center justify-center gap-x-4 text-xs">
              <Link href="https://corp.foodies-prime.com/aboutus">
                <div>運営会社</div>
              </Link>
              <div className="w-[1px] h-4 bg-white bg-opacity-30" />
              <Link href="https://corp.foodies-prime.com/contact">
                <div>お問い合わせ</div>
              </Link>
            </div>
            <small className="opacity-50 text-[10px] flex justify-center mt-3">
              &copy;Foodies Prime. All Right Reserved.
            </small>
          </div>
        </Container>
      </div>
    </>
  )
}
